
import { motion, AnimatePresence } from "framer-motion";

const Modal = ({
  isOpen,
  onClose,
  children,
  size = "md",
  className2,
  overflow = "overflow-y-scroll",
}) => {
  const sizeClasses = {
    sm: "max-w-xs",
    md: "max-w-md",
    lg: "max-w-xl",
    large: "max-w-2xl",
    extralarge: "max-w-5xl",
    extralarges: "max-w-7xl",
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={
            className2
              ? className2
              : `fixed inset-0 z-[404] flex items-start justify-center bg-black bg-opacity-50`
          }
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className={`relative w-full p-4 mt-5 ${sizeClasses[size]}`}
            initial={{ scale: 0.95, opacity: 0, y: 50 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 50 }}
            transition={{ duration: 0.3 }}
          >
            <button
              className="absolute top-0 right-0 w-[25px] h-[25px] text-gray-500 bg-red-200 rounded-full hover:text-gray-800 hover:bg-gray-100 transition-colors duration-200"
              onClick={onClose}
            >
              &times;
            </button>
            <div
              className={`w-full bg-white rounded-lg shadow-lg ${overflow} max-h-[80vh]`}
            >
              {children}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
